<template>
  <ValidationObserver ref="observer">
    <div>
      <component-header
        title="Create Request"
        :hasReload="true"
        @reload-data="reloadData"
        :hasSearch="false"
        :hasback="true"
        @back-press="$router.go(-1)"
        :hasCreate="false"
        :hasRequestList="true"
        @request-list-press="
          $router.push({ name: 'MyList', params: { id: $route.params.id } })
        "
        requestListButtonText="Request List"
      />
      <div class="card">
        <h4>Select Sub Category</h4>
        <b-row>
          <b-col cols="6">
            <div>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="Service Request"
              >
                <h5><i class="icon-maintenance"></i>Service Request</h5>
                <eb-select
                  id="service-request-dropdown"
                  class="w-100"
                  variant="light"
                  placeholder="Select Services"
                  block
                  v-model="selectedService"
                  :options="serviceOptions"
                  @change="handleServiceChange"
                  menu-class="dropdown-menu-custom"
                ></eb-select>
                <span class="validate-error custm-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </b-col>
          <b-col cols="6" v-if="selectedService === 'Maintenance and Repairs'">
            <div>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="Sub Service Request"
              >
                <h5>
                  <i class="icon-maintenance"></i> Maintenance and Repairs
                </h5>
                <eb-select
                  id="maintenance-dropdown"
                  class="w-100"
                  variant="light"
                  placeholder="Select Sub Services"
                  block
                  v-model="maintenance"
                  :options="maintenanceItems"
                  menu-class="dropdown-menu-custom"
                  @input="agentName"
                ></eb-select>
                <span class="validate-error custm-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </b-col>
          <b-col cols="6" v-else-if="selectedService === 'Cleaning Services'">
            <div>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="Sub Service Request"
              >
                <h5><i class="icon-cleaning"></i> Cleaning Services</h5>
                <eb-select
                  id="cleaning-dropdown"
                  class="w-100"
                  variant="light"
                  placeholder="Select Sub Services"
                  block
                  v-model="cleaning"
                  :options="cleaningItems"
                  menu-class="dropdown-menu-custom"
                  @input="agentName"
                ></eb-select>
                <span class="validate-error custm-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </b-col>
        </b-row>
        <div class="work-days-section mt-4">
          <h5>Select Work Day(s)</h5>
          <div>
            <label>
              <input
                type="checkbox"
                v-model="selectAll"
                @change="toggleSelectAll"
              />
              Select All
            </label>
          </div>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Select Work Day(s)"
          >
            <b-form-checkbox-group
              v-model="selectedDays"
              :options="daysOptions"
              class="work-days-checkboxes"
              @change="checkSelectAll"
            ></b-form-checkbox-group>
            <span class="validate-error custm-err">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="text-center mt-4">
          <b-button variant="primary" @click="bookService">Continue</b-button>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";

export default {
  components: {
    ComponentHeader,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
    Validator,
  },
  data() {
    return {
      catalogId: "",
      serviceOptions: [],
      selectedService: "",
      maintenanceItems: [],
      cleaningItems: [],
      maintenance: "",
      cleaning: "",
      daysOptions: [
        { text: "Monday", value: "Monday" },
        { text: "Tuesday", value: "Tuesday" },
        { text: "Wednesday", value: "Wednesday" },
        { text: "Thursday", value: "Thursday" },
        { text: "Friday", value: "Friday" },
        { text: "Saturday", value: "Saturday" },
        { text: "Sunday", value: "Sunday" },
      ],
      selectedDays: [],
      selectedMaintenanceItem: "",
      selectedCleaningItem: "",
      selectAll: false,
      selectRequestData: null,
    };
  },
  methods: {
    reloadData() {
      this.fetchMaintenanceItems();
      this.fetchCleaningServices();
      this.handleServiceChange();
      window.location.reload();
    },
    async handleServiceChange() {
      const response = await this.$store.dispatch(
        "onboardCustomer/fetchSubCategoriesAction",
        "66fd340ded96066ef00bf8a9"
      );
      this.serviceOptions = response.data.response.map((item) => item.name);
      if (this.selectedService === "Maintenance and Repairs") {
        this.fetchMaintenanceItems();
      } else if (this.selectedService === "Cleaning Services") {
        this.fetchCleaningServices();
      }
      return response;
    },
    async agentName(e) {
      const payload = {
        catalogId: e._id,
        provider: "66fd3e4a3ac1dda7694a4bc1",
      };
      try {
        const response = await this.$store.dispatch(
          "onboardCustomer/agentDetailsAction",
          payload
        );
        this.catalogId = e._id;
        this.selectRequestData = response.data.response;
        return response;
      } catch (error) {
        console.error("API error:", error);
      }
    },
    async bookService() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        catalog: [this.catalogId],
        categoryName: [],
        days: [],
        lat: 22.6636967,
        lng: 87.74680710000001,
        type: "SERVICE",
      };
      if (this.maintenance) {
        payload.catalog[0] = this.maintenance._id;
        payload.categoryName.push("Maintenance and Repairs");
      }
      if (this.cleaning) {
        payload.catalog[0] = this.cleaning._id;
        payload.categoryName.push("Cleaning Services");
      }
      if (this.selectedDays.length > 0) {
        payload.days = this.selectedDays;
      }
      try {
        await this.$store.dispatch("onboardCustomer/bookingAction", payload);
        this.$router.push({
          name: "bookingDetails",
          params: {
            data: payload,
            req: this.selectRequestData,
            listData: this.$route.params.listData,
          },
        });
      } catch (error) {
        console.error("API error:", error);
      }
    },
    async fetchMaintenanceItems() {
      const response = await this.$store.dispatch(
        "onboardCustomer/fetchSubCategoriesAction",
        "66fd3d45ed9606556f0bf8ac"
      );
      this.maintenanceItems = response.data.response.map((item) => item);
      return response;
    },
    async fetchCleaningServices() {
      const response2 = await this.$store.dispatch(
        "onboardCustomer/fetchSubCategoriesAction",
        "66fd3f5bed960603050bf8c1"
      );
      this.cleaningItems = response2.data.response.map((item) => item);
      return response2;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedDays = this.daysOptions.map((day) => day.value);
      } else {
        this.selectedDays = [];
      }
    },
    checkSelectAll() {
      this.selectAll = this.selectedDays.length === this.daysOptions.length;
    },
  },
  mounted() {
    this.fetchMaintenanceItems();
    this.fetchCleaningServices();
    this.handleServiceChange();
    const listData = this.$route.params.listData;
  },
};
</script>

<style scoped>
.card {
  height: 100vh;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border: 1px solid #eaeaea;
  margin-bottom: 20px;
}
.dropdown-item {
  display: inline-block !important;
  text-align: center;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
}
.dropdown-menu-custom {
  width: 100% !important;
}
.icon-maintenance::before {
  content: url("/public/img/png/Maintenance\ and\ repairs.png");
  margin-right: 8px;
}
.icon-cleaning::before {
  content: url("/public/img/png/Cleaning\ Services.png");
  margin-right: 8px;
}
.work-days-section {
  margin-top: 20px;
}
.work-days-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
h5 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #5a5a5a;
  margin-bottom: 10px;
}
</style>
